// Test IDs for the Sumatech Innovations one-page landing site.

export const LANDING = {
        navLogo: 'nav-logo',
        navMobileToggle: 'nav-mobile-toggle',
        heroCtaProducts: 'hero-cta-products',
        heroCtaContact: 'hero-cta-contact',
        contactFormName: 'contact-form-name',
        contactFormEmail: 'contact-form-email',
        contactFormCompany: 'contact-form-company',
        contactFormVertical: 'contact-form-vertical',
        contactFormMessage: 'contact-form-message',
        contactFormSubmit: 'contact-form-submit',
        chatBubbleToggle: 'chat-bubble-toggle',
        chatWidgetPanel: 'chat-widget-panel',
        chatWidgetClose: 'chat-widget-close',
        chatFormName: 'chat-form-name',
        chatFormEmail: 'chat-form-email',
        chatFormMessage: 'chat-form-message',
        chatFormSubmit: 'chat-form-submit',
        footerLogo: 'footer-logo',
};
